// 라우트의 ErrorBoundary 옵션으로 붙인 경계는 렌더 에러를 React Router 가 먼저 잡고 console.error 만 남긴다.
// 우리 ErrorBoundary 의 componentDidCatch 까지 에러가 오지 않으므로 useRouteError 로 받아 여기서 보고한다.

import { useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import { reporter } from '~/@common/utils/errorReporting/reporter'

import ErrorFallback from './ErrorFallback'

// 라우터 응답(없는 주소 404 등)은 크래시가 아니다. axios 에러는 빼지 않는다 — 보고 코드가 없는 인스턴스도 있고,
// maxios·noxios 가 이미 보고한 것은 파이프라인(4xx·5xx 버림)과 SDK Dedupe 가 중복을 거른다.
const isCrash = (error: unknown) => !isRouteErrorResponse(error)

const toError = (error: unknown) => (error instanceof Error ? error : new Error(String(error)))

const RouteErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    if (isCrash(error)) reporter.capture(error, { mechanism: 'boundary' })
  }, [error])

  // 크래시를 받은 경계가 아무것도 그리지 않으면 흰 화면이 된다. lazy 청크 로드가 복구까지 실패한 경우도 여기로 온다.
  if (!isCrash(error)) return null
  return <ErrorFallback error={toError(error)} />
}

export default RouteErrorBoundary
